(function() {
  'use strict';

  var API_BASE = 'https://fitment-api.oempartsdepartment.com/fitment';
  var STORAGE_KEY = 'oem_fitment_vehicle';
  var GARAGE_KEY = 'oem_garage_vehicle';

  var state = {
    make: null,
    model: null,
    year: null,
    sub_model: null
  };

  function getWidget() {
    return document.getElementById('fitment-widget');
  }

  function isCartMode() {
    var widget = getWidget();
    return widget && widget.dataset.mode === 'cart';
  }

  function getEl(id) {
    return document.getElementById('fitment-' + id);
  }

  function api(path, params) {
    var url = new URL(API_BASE + path);
    if (params) {
      Object.keys(params).forEach(function(k) {
        if (params[k]) url.searchParams.set(k, params[k]);
      });
    }
    return fetch(url.toString()).then(function(res) {
      if (!res.ok) throw new Error('API error: ' + res.status);
      return res.json();
    });
  }

  function saveVehicle() {
    try {
      var data = JSON.stringify(state);
      localStorage.setItem(STORAGE_KEY, data);
      localStorage.setItem(GARAGE_KEY, data);
    } catch (e) {}
  }

  function loadVehicle() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved);
      var garage = localStorage.getItem(GARAGE_KEY);
      if (garage) return JSON.parse(garage);
    } catch (e) {}
    return null;
  }

  function clearVehicle() {
    state.make = null;
    state.model = null;
    state.year = null;
    state.sub_model = null;
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(GARAGE_KEY);
    } catch(e) {}
  }

  function populateSelect(el, options, placeholder) {
    el.innerHTML = '<option value="">' + placeholder + '</option>';
    options.forEach(function(opt) {
      var o = document.createElement('option');
      o.value = opt;
      o.textContent = opt;
      el.appendChild(o);
    });
    el.disabled = false;
  }

  function disableSelect(el, placeholder) {
    el.innerHTML = '<option value="">' + placeholder + '</option>';
    el.disabled = true;
  }

  function showStatus(msg, type) {
    var el = getEl('status');
    if (!el) return;
    el.textContent = msg;
    el.className = 'fitment-status fitment-status--' + (type || 'info');
    el.style.display = msg ? 'block' : 'none';
  }

  function showSelectedBanner() {
    var banner = getEl('selected-banner');
    var form = getEl('form');
    if (!banner || !form) return;

    if (state.make && state.model && state.year) {
      var parts = [state.year, state.make, state.model];
      if (state.sub_model) parts.push(state.sub_model);
      banner.querySelector('.fitment-selected__text').textContent = parts.join(' ');
      banner.style.display = 'flex';
      form.style.display = 'none';
    } else {
      banner.style.display = 'none';
      form.style.display = 'grid';
    }
  }

  function dispatchVehicleEvent() {
    if (!isCartMode()) return;
    if (state.make && state.model && state.year) {
      document.dispatchEvent(new CustomEvent('fitment:vehicle-selected', {
        detail: { make: state.make, model: state.model, year: state.year, sub_model: state.sub_model || '' }
      }));
    }
  }

  function dispatchClearEvent() {
    if (!isCartMode()) return;
    document.dispatchEvent(new CustomEvent('fitment:vehicle-cleared'));
  }

  function loadMakes() {
    var sel = getEl('make');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/makes').then(function(data) {
      populateSelect(sel, data.makes, 'Select Make');
    }).catch(function(e) {
      console.error('Failed to load makes:', e);
      disableSelect(sel, 'Error loading makes');
    });
  }

  function loadModels(make) {
    var sel = getEl('model');
    disableSelect(getEl('year'), 'Select Year');
    disableSelect(getEl('sub_model'), 'Select Sub-Model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/models', { make: make }).then(function(data) {
      populateSelect(sel, data.models, 'Select Model');
    }).catch(function(e) {
      console.error('Failed to load models:', e);
      disableSelect(sel, 'Error loading models');
    });
  }

  function loadYears(make, model) {
    var sel = getEl('year');
    disableSelect(getEl('sub_model'), 'Select Sub-Model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/years', { make: make, model: model }).then(function(data) {
      populateSelect(sel, data.years, 'Select Year');
    }).catch(function(e) {
      console.error('Failed to load years:', e);
      disableSelect(sel, 'Error loading years');
    });
  }

  function loadSubModels(make, model, year) {
    var sel = getEl('sub_model');
    sel.disabled = true;
    sel.innerHTML = '<option value="">Loading...</option>';
    api('/sub_models', { make: make, model: model, year: year }).then(function(data) {
      if (data.sub_models && data.sub_models.length > 0) {
        populateSelect(sel, data.sub_models, 'Select Sub-Model (Optional)');
      } else {
        disableSelect(sel, 'No sub-models');
      }
    }).catch(function(e) {
      console.error('Failed to load sub-models:', e);
      disableSelect(sel, 'Error loading sub-models');
    });
  }

  function getCartSkus() {
    if (window.__cart_skus && window.__cart_skus.length > 0) {
      return window.__cart_skus.filter(function(s, i, arr) { return arr.indexOf(s) === i; });
    }
    return [];
  }

  function getCartItemName(sku) {
    if (window.__cart_items_info) {
      var item = window.__cart_items_info.find(function(i) { return i.sku === sku; });
      if (item) return item.title;
    }
    return sku;
  }

  function updateGalleryVehicleContext(vehicleName, fits) {
    var banner = document.getElementById('gallery-vehicle-context');
    if (!banner) return;
    if (!vehicleName) {
      banner.style.display = 'none';
      banner.className = 'gallery-vehicle-context';
      return;
    }
    banner.style.display = 'flex';
    if (fits) {
      banner.className = 'gallery-vehicle-context gallery-vehicle-context--fits';
      banner.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span>Showing parts for your <strong>' + vehicleName + '</strong></span>';
    } else {
      banner.className = 'gallery-vehicle-context gallery-vehicle-context--nofit';
      banner.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '<span>This part may not fit your <strong>' + vehicleName + '</strong></span>';
    }
  }

  function updateCollectionCards(validSkus) {
    var cards = document.querySelectorAll('[data-product-sku]');
    if (!cards.length) return;
    cards.forEach(function(card) {
      var sku = card.dataset.productSku;
      var badge = card.querySelector('.fitment-card-badge');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'fitment-card-badge';
        var mediaEl = card.querySelector('.card__media');
        if (mediaEl) mediaEl.style.position = 'relative';
        (mediaEl || card).appendChild(badge);
      }
      if (validSkus === null) {
        badge.style.display = 'none';
      } else if (validSkus.indexOf(sku) !== -1) {
        badge.style.display = 'flex';
        badge.className = 'fitment-card-badge fitment-card-badge--fits';
        badge.innerHTML = '✓ Fits';
      } else {
        badge.style.display = 'flex';
        badge.className = 'fitment-card-badge fitment-card-badge--nofit';
        badge.innerHTML = '✗ May not fit';
      }
    });
  }

  function validateFitment() {
    if (!state.make || !state.model || !state.year) return;

    var widget = getWidget();
    if (!widget) return;

    var variantSkus = [];

    if (isCartMode()) {
      variantSkus = getCartSkus();
    } else {
      var skuAttr = widget.dataset.productSku;
      if (skuAttr) variantSkus.push(skuAttr);

      if (window.__fitment_skus && window.__fitment_skus.length > 0) {
        window.__fitment_skus.forEach(function(s) {
          if (s && variantSkus.indexOf(s) === -1) variantSkus.push(s);
        });
      }
    }

    if (variantSkus.length === 0) {
      showStatus('', 'info');
      return;
    }

    var vehicleName = state.year + ' ' + state.make + ' ' + state.model;
    showStatus('Checking fitment...', 'info');

    fetch(API_BASE + '/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year: state.year,
        make: state.make,
        model: state.model,
        sub_model: state.sub_model || undefined,
        skus: variantSkus
      })
    }).then(function(res) {
      return res.json();
    }).then(function(result) {
      if (result.results) {
        if (isCartMode()) {
          renderCartResults(result.results, vehicleName);
        } else {
          var match = result.results.find(function(r) { return r.valid; });
          if (match) {
            var msg = '✅ This part fits your ' + vehicleName;
            if (match.engine) msg += ' (' + match.engine + ')';
            showStatus(msg, 'success');
            updateGalleryVehicleContext(vehicleName, true);
          } else {
            showStatus('⚠️ This part may not fit your ' + vehicleName + '. Please verify before purchasing.', 'warning');
            updateGalleryVehicleContext(vehicleName, false);
          }
          var validSkus = result.results.filter(function(r) { return r.valid; }).map(function(r) { return r.sku; });
          updateCollectionCards(validSkus);
        }
      }
    }).catch(function(e) {
      console.error('Fitment validation error:', e);
      showStatus('Unable to verify fitment. Please try again.', 'info');
    });
  }

  function renderCartResults(results, vehicleName) {
    var resultsEl = document.getElementById('cart-fitment-results');
    if (!resultsEl) {
      showStatus('', 'info');
      return;
    }

    var allFit = results.every(function(r) { return r.valid; });
    var anyFit = results.some(function(r) { return r.valid; });

    if (allFit) {
      showStatus('✅ All items in your cart fit your ' + vehicleName, 'success');
    } else if (!anyFit) {
      showStatus('⚠️ Items in your cart may not fit your ' + vehicleName + '. Please verify before purchasing.', 'warning');
    } else {
      showStatus('Some items may not fit your ' + vehicleName + '. See details below.', 'warning');
    }

    if (results.length > 1) {
      var html = '';
      results.forEach(function(r) {
        if (r.valid) {
          html += '<div class="cart-fitment__item cart-fitment__item--fit">';
          html += '<span class="cart-fitment__item-icon">✅</span>';
          html += '<span class="cart-fitment__item-name">' + getCartItemName(r.sku) + '</span>';
          if (r.engine) html += '<span>(' + r.engine + ')</span>';
          html += '</div>';
        } else {
          html += '<div class="cart-fitment__item cart-fitment__item--nofit">';
          html += '<span class="cart-fitment__item-icon">⚠️</span>';
          html += '<span class="cart-fitment__item-name">' + getCartItemName(r.sku) + ' — may not fit</span>';
          html += '</div>';
        }
      });
      resultsEl.innerHTML = html;
    } else {
      resultsEl.innerHTML = '';
    }
  }

  function bindEvents() {
    var makeEl = getEl('make');
    var modelEl = getEl('model');
    var yearEl = getEl('year');
    var subEl = getEl('sub_model');
    var changeBtn = getEl('change-btn');

    if (makeEl) {
      makeEl.addEventListener('change', function() {
        state.make = this.value || null;
        state.model = null;
        state.year = null;
        state.sub_model = null;
        if (state.make) {
          loadModels(state.make);
        } else {
          disableSelect(modelEl, 'Select Model');
          disableSelect(yearEl, 'Select Year');
          disableSelect(subEl, 'Select Sub-Model');
        }
        showStatus('', 'info');
        saveVehicle();
        showSelectedBanner();
      });
    }

    if (modelEl) {
      modelEl.addEventListener('change', function() {
        state.model = this.value || null;
        state.year = null;
        state.sub_model = null;
        if (state.make && state.model) {
          loadYears(state.make, state.model);
        } else {
          disableSelect(yearEl, 'Select Year');
          disableSelect(subEl, 'Select Sub-Model');
        }
        showStatus('', 'info');
        saveVehicle();
        showSelectedBanner();
      });
    }

    if (yearEl) {
      yearEl.addEventListener('change', function() {
        state.year = this.value || null;
        state.sub_model = null;
        if (state.make && state.model && state.year) {
          loadSubModels(state.make, state.model, state.year);
          saveVehicle();
          showSelectedBanner();
          dispatchVehicleEvent();
          validateFitment();
          validateCollectionCards();
        } else {
          disableSelect(subEl, 'Select Sub-Model');
        }
        showStatus('', 'info');
      });
    }

    if (subEl) {
      subEl.addEventListener('change', function() {
        state.sub_model = this.value || null;
        saveVehicle();
        dispatchVehicleEvent();
        validateFitment();
        validateCollectionCards();
      });
    }

    if (changeBtn) {
      changeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        clearVehicle();
        disableSelect(modelEl, 'Select Model');
        disableSelect(yearEl, 'Select Year');
        disableSelect(subEl, 'Select Sub-Model');
        showStatus('', 'info');
        var resultsEl = document.getElementById('cart-fitment-results');
        if (resultsEl) resultsEl.innerHTML = '';
        showSelectedBanner();
        dispatchClearEvent();
        updateGalleryVehicleContext(null);
        updateCollectionCards(null);
        loadMakes();
      });
    }
  }

  function restoreSaved() {
    var saved = loadVehicle();
    if (!saved || !saved.make) return;

    Object.assign(state, saved);

    var makeEl = getEl('make');
    var modelEl = getEl('model');
    var yearEl = getEl('year');
    var subEl = getEl('sub_model');

    api('/makes').then(function(data) {
      populateSelect(makeEl, data.makes, 'Select Make');
      if (state.make) {
        makeEl.value = state.make;
        return api('/models', { make: state.make });
      }
    }).then(function(data) {
      if (data && data.models) {
        populateSelect(modelEl, data.models, 'Select Model');
        if (state.model) {
          modelEl.value = state.model;
          return api('/years', { make: state.make, model: state.model });
        }
      }
    }).then(function(data) {
      if (data && data.years) {
        populateSelect(yearEl, data.years, 'Select Year');
        if (state.year) {
          yearEl.value = state.year;
          return api('/sub_models', { make: state.make, model: state.model, year: state.year });
        }
      }
    }).then(function(data) {
      if (data && data.sub_models && data.sub_models.length > 0) {
        populateSelect(subEl, data.sub_models, 'Select Sub-Model (Optional)');
        if (state.sub_model) {
          subEl.value = state.sub_model;
        }
      } else if (data) {
        disableSelect(subEl, 'No sub-models');
      }
      showSelectedBanner();
      dispatchVehicleEvent();
      validateFitment();
      validateCollectionCards();
    }).catch(function(e) {
      console.error('Error restoring saved vehicle:', e);
      loadMakes();
    });
  }

  function validateCollectionCards() {
    var cards = document.querySelectorAll('[data-product-sku]');
    if (!cards.length || !state.make || !state.model || !state.year) return;

    var skus = [];
    cards.forEach(function(card) {
      var sku = card.dataset.productSku;
      if (sku && skus.indexOf(sku) === -1) skus.push(sku);
    });
    if (!skus.length) return;

    fetch(API_BASE + '/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year: state.year,
        make: state.make,
        model: state.model,
        sub_model: state.sub_model || undefined,
        skus: skus
      })
    }).then(function(res) {
      return res.json();
    }).then(function(result) {
      if (result.results) {
        var validSkus = result.results.filter(function(r) { return r.valid; }).map(function(r) { return r.sku; });
        updateCollectionCards(validSkus);
      }
    }).catch(function(e) {
      console.error('Collection fitment check error:', e);
    });
  }

  function init() {
    var widget = getWidget();
    if (!widget) return;

    bindEvents();

    if (!isCartMode()) {
      document.addEventListener('change', function(e) {
        var target = e.target;
        if (target && target.name && target.name.indexOf('id') !== -1 && target.closest('[data-section-id]')) {
          var selectedOption = target.options ? target.options[target.selectedIndex] : null;
          if (selectedOption && selectedOption.dataset && selectedOption.dataset.sku) {
            widget.dataset.productSku = selectedOption.dataset.sku;
          }
          if (state.make && state.model && state.year) {
            validateFitment();
          }
        }
      });
    }

    var saved = loadVehicle();
    if (saved && saved.make) {
      restoreSaved();
    } else {
      loadMakes();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
